

import WebFontLoader from 'webfontloader'

// async load fonts
WebFontLoader.load({
  google: {
    families: [
      'Material+Icons',
    ],
  },
  custom: {
    families: [
      'Material Design Icons',
      'Font Awesome 5',
    ],
    urls: [
      'https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css',
      'build/fonts/fontawesome-free/css/all.css',
    ],
  },
})
